import type { GetMeResponseDTO } from "../../domain/dto/ProfileDTO";
import type { UserProfile } from "../../domain/entities/Profile";
import { normalizeOtpPreference } from "@/features/auth/domain/constants/otpConstants";
import { readTotpEnabledFromSources } from "@/features/auth/domain/utils/readTotpEnabled";

export const mapGetMeResponse = (response: GetMeResponseDTO): UserProfile => {
  const { user, hospital, settings, is_password_set } = response.data;

  const createdAt = user.created_at
    ? new Date(user.created_at).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

  return {
    id: user.id,
    name: user.name,
    email: user.email,
    phone: user.phone,
    role: user.designation_name,
    createdAt,
    status: user.is_active ? "Active" : "Inactive",
    hospitalName: hospital?.name,
    city: hospital?.location?.city_name,
    state: hospital?.location?.state_name,
    country: hospital?.location?.country_name,
    totpEnabled: readTotpEnabledFromSources(
      response.data as Record<string, unknown>,
      settings as Record<string, unknown> | undefined,
    ),
    isPasswordSet: is_password_set,
    otpPreference: normalizeOtpPreference(settings?.otp_preference) ?? undefined,
    permissions: [],
  };
};
